import { Route, Routes } from 'react-router-dom'
import Layout from './atz/Layout'
import Home from './atz/pages/Home'
import About from './atz/pages/About'
import Services from './atz/pages/Services'
import SamRegistration from './atz/pages/SamRegistration'
import Portfolio from './atz/pages/Portfolio'
import PortfolioMold from './atz/pages/PortfolioMold'
import PortfolioElevator from './atz/pages/PortfolioElevator'
import Contact from './atz/pages/Contact'
import BlogList from './atz/pages/BlogList'
import BlogPost from './pages/BlogPost'
import NotFound from './atz/pages/NotFound'

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/sam-registration" element={<SamRegistration />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/projects/stanton-basement-mold-restoration" element={<PortfolioMold />} />
        <Route path="/projects/coast-guard-elevator-maintenance" element={<PortfolioElevator />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/blogs" element={<BlogList />} />
        <Route path="/:slug" element={<BlogPost />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}

export default App
